import React, { useState, useLayoutEffect, useContext } from 'react';

import { LayoutContext } from '../../context/layoutContext';

import { IoIosSearch } from 'react-icons/io';

import { TabSearchStyled, Button } from '../../styles/commonStyles';
import _ from 'lodash';

const SELECT_OPTION = [
  { id: 'title', text: '제목' },
  { id: 'contents', text: '내용' },
  { id: 'createdAt', text: '날짜' },
];

const SearchTabs = ({ write, rtSearchValue, opContentsHide, opDateHide, searchOptionEpNoOpen }) => {
  const { matchese } = useContext(LayoutContext);

  const [tab, setTab] = useState('title');
  const [input, setInput] = useState('');

  const [selectOption, setSelectOption] = useState([]);

  const [delay, setDelay] = useState('');

  useLayoutEffect(() => {
    let option = _.cloneDeep(SELECT_OPTION);

    if (opContentsHide) option = option.filter(a => a?.id !== 'contents');
    if (opDateHide) option = option.filter(a => a?.id !== 'createdAt');
    if (searchOptionEpNoOpen) option.push({ id: 'episodeNo', text: '회차순' });

    setSelectOption(option);
  }, [opContentsHide, opDateHide]);

  const rtInputValue = e => {
    let text = e?.target?.value;
    setInput(text);

    if (matchese) {
      if (delay) clearTimeout(delay);

      let _delay = setTimeout(async () => {
        searchValue(text);
      }, 300);

      setDelay(_delay);
    }
  };

  const rtSelectValue = e => {
    setTab(e.target.value);
  };

  const handleEnterKeyDown = e => {
    if (e.keyCode === 13) {
      searchValue(input);
    }
  };

  const searchValue = text => {
    let result = {
      tab: tab,
      value: text,
    };

    rtSearchValue(result);
    if (!matchese) setInput('');
  };

  return (
    <TabSearchStyled write={write}>
      <select onChange={e => rtSelectValue(e)}>
        {selectOption.map((op, idx) => (
          <option key={`${op?.id}_${idx}`} value={op?.id}>
            {op?.text}
          </option>
        ))}
      </select>
      <span>
        <input type='text' placeholder='검색어 입력' value={input} onChange={e => rtInputValue(e)} onKeyDown={handleEnterKeyDown} />
        <IoIosSearch />
      </span>
      {write && <Button onClick={write}>글쓰기</Button>}
    </TabSearchStyled>
  );
};

export default SearchTabs;
